var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmooss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_96",
    "data-name": "Groupe 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302.619,
    height: 59.924,
    viewBox: "0 0 302.619 59.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 302.619,
    height: 59.922,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M68.557,28.488A27.175,27.175,0,1,1,95.743,55.881,27.288,27.288,0,0,1,68.557,28.488M95.907,0a28.313,28.313,0,1,0,28.324,28.324A28.309,28.309,0,0,0,95.907,0Z",
    transform: "translate(-67.605 0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.247,
    y1: 0.923,
    x2: -1.227,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ba6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#fee0b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#e2b566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#fadaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#ddb061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#c29245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fadaaa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M69.541,30.225A27.176,27.176,0,1,1,96.727,57.616,27.288,27.288,0,0,1,69.541,30.225m-.952-.166a28.313,28.313,0,1,0,28.3-28.322,28.289,28.289,0,0,0-28.3,28.322",
    transform: "translate(-68.589 -1.736)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.267,
    y1: 0.888,
    x2: -1.247,
    y2: 0.888,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M95.525,28.488a27.175,27.175,0,1,1,27.184,27.393A27.288,27.288,0,0,1,95.525,28.488M122.875,0A28.313,28.313,0,1,0,151.2,28.323,28.307,28.307,0,0,0,122.875,0Z",
    transform: "translate(-94.573 0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.793,
    y1: 0.923,
    x2: -1.772,
    y2: 0.923,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M96.509,30.225a27.175,27.175,0,1,1,27.184,27.392A27.287,27.287,0,0,1,96.509,30.225m-.952-.166a28.312,28.312,0,1,0,28.3-28.322,28.289,28.289,0,0,0-28.3,28.322",
    transform: "translate(-95.557 -1.736)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.813,
    y1: 0.888,
    x2: -1.792,
    y2: 0.888,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_79",
    "data-name": "Groupe 79",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_78",
    "data-name": "Groupe 78",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M0,16.1C0,34.135,35.419,29.47,35.419,46.02c0,6.1-6.325,11.982-14.353,11.982C7.974,58,.776,44.922.776,44.922H.227v7.36c4.061,3.028,10.495,6.712,17.758,6.712,12.7,0,20.624-7.585,20.624-15.235,0-19.245-34.762-13.911-34.762-28.976,0-6.1,5.615-12.317,15.841-12.317,11.766,0,15.128,9.234,15.128,9.234h.549V4.33A46.335,46.335,0,0,0,19.687,1.809C6.983,1.809,0,8.458,0,16.1",
    transform: "translate(0 0.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M28.776,2.536v.549c4.73,0,5.064,3.9,5.064,14.73V42.232c0,10.84-.334,14.741-5.064,14.741v.549H43.624v-.549c-4.73,0-9.234-3.954-9.234-19.967V30.024l.054-23.588c8.351,17.93,13.308,28.6,21.938,47.066h.5C63.645,35.358,69.194,20.239,75.131,4.346V42.232c0,10.84-.322,14.741-5.054,14.741v.549h14.85v-.549c-4.731,0-5.064-3.9-5.064-14.741V17.815c0-10.829.333-14.73,5.064-14.73V2.536H75.239l-16.5,44.319L37.634,2.536Z",
    transform: "translate(14.765 1.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M135.213,16.1c0,18.038,35.419,13.373,35.419,29.923,0,6.1-6.325,11.982-14.353,11.982-13.091,0-20.289-13.081-20.289-13.081h-.549v7.36c4.061,3.028,10.495,6.712,17.758,6.712,12.7,0,20.624-7.585,20.624-15.235,0-19.245-34.762-13.911-34.762-28.976,0-6.1,5.615-12.317,15.841-12.317,11.766,0,15.128,9.234,15.128,9.234h.549V4.33A46.335,46.335,0,0,0,154.9,1.809c-12.7,0-19.687,6.649-19.687,14.288",
    transform: "translate(69.377 0.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M165.078,16.1c0,18.038,35.419,13.373,35.419,29.923,0,6.1-6.325,11.982-14.353,11.982-13.091,0-20.289-13.081-20.289-13.081h-.549v7.36c4.061,3.028,10.495,6.712,17.758,6.712,12.7,0,20.623-7.585,20.623-15.235,0-19.245-34.762-13.911-34.762-28.976,0-6.1,5.615-12.317,15.841-12.317,11.766,0,15.128,9.234,15.128,9.234h.549V4.33a46.335,46.335,0,0,0-15.677-2.521c-12.7,0-19.687,6.649-19.687,14.288",
    transform: "translate(84.701 0.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M198.629,9.169a2.067,2.067,0,0,0,1.7-.711c.831,2.371-.819,5.99-3.19,6.541l.054.549s5.4-1.369,5.4-8.793c0-3.3-1.929-4.946-3.966-4.946a3.68,3.68,0,1,0,0,7.36",
    transform: "translate(100.025 0.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M95.42.725a27.393,27.393,0,1,0,27.163,27.392A27.288,27.288,0,0,0,95.42.725M95.585,54.7a26.751,26.751,0,1,1,26.75-26.75A26.779,26.779,0,0,1,95.585,54.7",
    transform: "translate(35.011 0.371)",
    fill: "#c29245"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_81",
    "data-name": "Groupe 81",
    transform: "translate(102.293 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_80",
    "data-name": "Groupe 80",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 74.767,
    height: 74.767,
    transform: "translate(-21.047 9.375) rotate(-24.009)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_83",
    "data-name": "Groupe 83",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_82",
    "data-name": "Groupe 82",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M96.4,2.461a27.393,27.393,0,1,0,27.163,27.392A27.288,27.288,0,0,0,96.4,2.461m.165,53.977a26.751,26.751,0,1,1,26.75-26.75,26.779,26.779,0,0,1-26.75,26.75",
    transform: "translate(35.516 1.262)",
    fill: "#c29245"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_85",
    "data-name": "Groupe 85",
    transform: "translate(103.782 2.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_84",
    "data-name": "Groupe 84",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 74.766,
    height: 74.765,
    transform: "translate(-21.046 9.375) rotate(-24.009)",
    fill: "url(#linear-gradient-2)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_87",
    "data-name": "Groupe 87",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_86",
    "data-name": "Groupe 86",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M122.387.725A27.393,27.393,0,1,0,149.55,28.117,27.288,27.288,0,0,0,122.387.725m.165,53.977a26.751,26.751,0,1,1,26.75-26.75,26.779,26.779,0,0,1-26.75,26.75",
    transform: "translate(48.847 0.371)",
    fill: "#c29245"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_89",
    "data-name": "Groupe 89",
    transform: "translate(143.098 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_88",
    "data-name": "Groupe 88",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 74.765,
    height: 74.766,
    transform: "translate(-21.047 9.375) rotate(-24.009)",
    fill: "url(#linear-gradient-3)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_91",
    "data-name": "Groupe 91",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_90",
    "data-name": "Groupe 90",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M123.371,2.461a27.393,27.393,0,1,0,27.163,27.392A27.288,27.288,0,0,0,123.371,2.461m.165,53.977a26.751,26.751,0,1,1,26.75-26.75,26.779,26.779,0,0,1-26.75,26.75",
    transform: "translate(49.352 1.262)",
    fill: "#c29245"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_93",
    "data-name": "Groupe 93",
    transform: "translate(144.587 2.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_92",
    "data-name": "Groupe 92",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 74.765,
    height: 74.765,
    transform: "translate(-21.046 9.375) rotate(-24.009)",
    fill: "url(#linear-gradient-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmooss);
export default __webpack_public_path__ + "static/media/smooss.819f39adb24b5705e4fb40f98f763761.svg";
export { ForwardRef as ReactComponent };